import {gql} from '@apollo/client';

export const GetInstitutionAddressFormat = gql`
    query GetInstitutionAddressFormat($institutionId: InstitutionId!) {
        institutions(institutionId: $institutionId) {
            institutionId
            addressFormatting {
                format
            }
        }
    }
`;

export const UserContextFragment = gql`
    fragment UserContextFragment on UserContext {
        id
        target {
            __typename
            ... on PersonContextTarget {
                person {
                    name {
                        fullName
                    }
                }
                children {
                    id
                    institutionId
                    birthday
                    name {
                        firstName
                        lastName
                        fullName
                    }
                    profileImage {
                        url
                    }
                }
            }
            ... on InstitutionSet {
                title
                profileImage {
                    url
                }
            }
        }
    }
`;

export const ActiveAndAvailableUserContexts = gql`
    query GetCurrentContext {
        me {
            currentContext {
                ...UserContextFragment
            }
            availableContexts {
                ...UserContextFragment
            }
        }
    }
    ${UserContextFragment}
`;
